<template>
  <div v-if="news.path" class="h-100 relative hide-child cover center background-center flex items-end" :style="{'background-image': `url(${picture})`}">
    <span @click="open" class="white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer">
      <font-awesome-icon class="white" icon="external-link-alt" size="2x"/>
    </span>
    <div class="flex items-end w-100 justify-between">
      <div @click="open" class="content-card bg-primary ml2 ml4-ns mb4 tc white pa3 flex pointer">
        <p class="f4-ns ma0 mt3-ns mt2 f5 text-ellipsis" :title="news.title">{{ news.title }}</p>
      </div>
      <div @click="open" class="home-button bg-primary mr4 mb4 tc pa3 br-100 pointer">
        <font-awesome-icon class="white" icon="external-link-alt" size="1x"/>
      </div>
    </div>
  </div>
</template>

<script>

import consts from '@/consts'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
export default {
  name: 'news',
  props: {
    news: {
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    picture () {
      return consts.MEDIA_BASE_URL + this.news.path + this.news.image
    }
  },
  methods: {
    open () {
      if (this.news) {
        this.$router.push({ name: 'news', params: { id: this.news.id } })
      }
    }
  }
}
</script>


<style lang="scss" scoped>

  .content-card {
    min-width: 30%;
    min-height: 20%;
    max-width: 60%;
    max-height: 70%;
  }

  .home-button {
    display: none;
  }
  @media (max-width: 768px) {
    .home-button {
      max-width: 50px;
      max-height: 50px;
      width: 50px;
      height: 50px;
      display: block
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue